import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

export type IssueSeverity = "critical" | "warning" | "info";

interface SeverityBadgeProps {
	severity: IssueSeverity;
	size?: "sm" | "md";
}

const severityConfig: Record<
	IssueSeverity,
	{ label: string; className: string }
> = {
	critical: {
		label: "Critical",
		className: "bg-red-500 text-white hover:bg-red-600",
	},
	warning: {
		label: "Warning",
		className: "bg-yellow-500 text-white hover:bg-yellow-600",
	},
	info: {
		label: "Info",
		className: "bg-blue-500 text-white hover:bg-blue-600",
	},
};

export function SeverityBadge({ severity, size = "md" }: SeverityBadgeProps) {
	const config = severityConfig[severity];

	return (
		<Badge
			className={cn(config.className, size === "sm" && "text-xs px-1.5 py-0.5")}
		>
			{config.label}
		</Badge>
	);
}
